const TrackingContainer = () => import(/* webpackPrefetch: true, webpackChunkName: "tracking-container" */ '@/app/views/main-view/tracking/containers/tracking-container/tracking-container.vue');
const UsersContainer = () => import(/* webpackPrefetch: true, webpackChunkName: "users-container" */ '@/app/views/main-view/users/containers/users-container/users-container.vue');
const ProductsContainer = () => import(/* webpackPrefetch: true, webpackChunkName: "products-container" */ '@/app/views/main-view/products/containers/products-container/products-container.vue');
const BundlesContainer = () => import(/* webpackPrefetch: true, webpackChunkName: "bundles-container" */ '@/app/views/main-view/bundles/containers/bundles-container/bundles-container.vue');

export default {
  name: 'DashboardContainer',
  components: {
    TrackingContainer,
    UsersContainer,
    ProductsContainer,
    BundlesContainer
  }
}